import { render, staticRenderFns } from "./disposalAddWasteForm.vue?vue&type=template&id=82afda60&scoped=true&"
import script from "./disposalAddWasteForm.vue?vue&type=script&lang=js&"
export * from "./disposalAddWasteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82afda60",
  null
  
)

export default component.exports